/**
 * OrderView Component
 */

import './order-view.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import Button from '../../../atoms/buttons/Button';
import { IconInvoice, IconMusicNote, IconTerms } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import Invoice from '../../../organisms/account/Invoice';
import License from '../../../organisms/account/License';
import OrderFileList from '../../../organisms/account/OrderFileList';
import { OrderDocumentType } from './';

interface IOwnProps {
  className?: string;
  defaultDocument?: OrderDocumentType;
  order: GQL.IOrder;
  isFetching?: boolean;
  onSwitchDocument?: (document: OrderDocumentType) => void;
}

interface IOwnState {
  currentDocument: OrderDocumentType;
}

type OrderViewProps = IOwnProps;

const classes = new BEM('order-view');

export default class OrderView extends React.Component<OrderViewProps, IOwnState> {
  constructor(props: OrderViewProps) {
    super(props);

    this.state = {
      currentDocument: props.defaultDocument || 'invoice',
    };
  }

  componentWillReceiveProps(nextProps: OrderViewProps) {
    if (nextProps.order.id !== this.props.order.id) {
      if (!nextProps.order.license_line_items!.length
      && this.state.currentDocument !== 'invoice') {
        this.setState({ currentDocument: 'invoice' });
      }
    }
  }

  componentDidUpdate(_, prevState: IOwnState) {
    if (prevState.currentDocument !== this.state.currentDocument) {
      if (this.props.onSwitchDocument) {
        this.props.onSwitchDocument(this.state.currentDocument);
      }
    }
  }

  renderDocument() {
    let Component: React.ComponentClass<{data: GQL.IOrder}>;
    switch (this.state.currentDocument) {
      case 'license':
        Component = License;
        break;
      case 'music':
        Component = OrderFileList;
        break;
      default:
        Component = Invoice;
        break;
    }

    return <Component key={this.state.currentDocument} data={this.props.order} />;
  }

  render() {
    const { isFetching, order } = this.props;
    return (
      <div {...classes('', { fetching: !!isFetching })}>
        <div {...classes('nav')}>
          <Button
            label="Invoice"
            icon={<IconInvoice />}
            onClick={() => this.setState({ currentDocument: 'invoice' })}
            disabled={isFetching}
            {...classes('nav__button', { active: this.state.currentDocument === 'invoice' })}
          />
          {!!order.license_line_items!.length && (<>
            <Button
              label="License"
              icon={<IconTerms />}
              onClick={() => this.setState({ currentDocument: 'license' })}
              disabled={isFetching}
              {...classes('nav__button', { active: this.state.currentDocument === 'license' })}
            />
            <Button
              label="Files"
              icon={<IconMusicNote />}
              onClick={() => this.setState({ currentDocument: 'music' })}
              disabled={isFetching}
              {...classes('nav__button', { active: this.state.currentDocument === 'music' })}
            />
          </>)}
        </div>
        <div {...classes('document')}>
          <VelocityTransitionGroup
            component="div"
            enter={{
              animation: isFetching ? 'transition.shrinkIn' : 'transition.slideUpIn',
              delay: 250,
              display: 'block',
              duration: 250,
            }}
            leave={{
              animation: 'transition.fadeOut',
              duration: 150,
            }}
            {...classes('document__content')}
          >
            {isFetching ? (
              <div key="fetching" {...classes('fetching')}>
                <Heading is="h3" {...classes('fetching__title')}>Retrieving order...</Heading>
              </div>
            ) : this.renderDocument()}
          </VelocityTransitionGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Orders/OrderView.tsx